import { IonButton, IonIcon } from "@ionic/react";
import { pause, play } from "ionicons/icons";

export default function PlayPauseButton({ running, onClick }) {
  return (
    <IonButton className={running ? "timer-button running" : "timer-button"} onClick={onClick} aria-label={running ? "Pause timer" : "Start timer"}>
      <IonIcon icon={running ? pause : play} />
    </IonButton>
  );
}
